<template>
  <div class="cadfm-container-horizontal">
            <Left v-show="isVisibleLeft" :lang="lang.Left"></Left>
            <Middle :routingData="routingData" :lang="lang.Middle"></Middle>
            <!--<Right></Right>-->
 </div>
</template>

<script>
import Left from '@/components/LibraryManager/Views/LibraryDerive/Left/Left'
import Middle from '@/components/LibraryManager/Views/LibraryDerive/Middle/Middle'
//import Right from '@/components/LibraryManager/Views/LibraryDerive/Right/Right'
import { mapGetters } from 'vuex'


export default {
  name: 'LibraryDerive',
  components:{
    Left,
    Middle,
    //Right
  },
  props:{
    routingData: Object,
    lang: Object
  },
  data () {
    return {
      isVisibleRight: true,
      isVisibleLeft: true
    }
  },
  computed: {
    ...mapGetters([
      'isPlugin',
      
    ]),
  
  },
  
}

</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/LibraryManager/Views/LibraryDerive.vue